module.exports = __webpack_public_path__ + "img/4C.e1dfc148.svg";